// extracted by mini-css-extract-plugin
export default {"container":"container--y3pax","background":"background--heXmT"};